import { resolveApiUrl } from '@/providers/api-url';

/**
 * Превращает file-URL из бэкенда в абсолютный, пригодный для `<img src>`.
 *
 * Зачем: админка и API живут на РАЗНЫХ доменах в проде
 * (`admin.mc.inexbrand.uz` против `api.mc.inexbrand.uz`). Бэкенд в
 * `buildFileUrl` отдаёт относительные пути:
 *   - `/uploads/public/...`      — статика, обслуживается на root API
 *   - `/api/files/:id/stream`    — приватные файлы через API-прокси
 *   - `https://cdn.../...`       — абсолютный B2 CDN URL
 *
 * Относительный `/uploads/...`, подставленный в `<img>` на админ-домене,
 * резолвится браузером от origin админки, где такого файла нет — nginx
 * отдаёт SPA-фоллбэк (index.html) вместо картинки. Отсюда баг
 * «файл сохранён, но не отображается». Этот helper всегда привязывает
 * относительный путь к origin API.
 *
 * @param fileUrl относительный или абсолютный URL файла, либо null/undefined
 * @returns абсолютный URL, либо пустая строка если входа нет
 */
export function resolveFileUrl(fileUrl: string | null | undefined): string {
  if (!fileUrl) {
    return '';
  }

  // Уже абсолютный (B2 CDN, внешний хост) — отдаём как есть.
  if (/^https?:\/\//i.test(fileUrl)) {
    return fileUrl;
  }

  // resolveApiUrl() возвращает базу С суффиксом `/api`
  // (например `https://api.mc.inexbrand.uz/api`). Origin файлов —
  // тот же хост, но `/uploads/*` сидит на root, а `/api/*` под `/api`.
  const apiBase = resolveApiUrl();
  const origin = apiBase.replace(/\/api\/?$/, '');

  const path = fileUrl.startsWith('/') ? fileUrl : `/${fileUrl}`;
  return `${origin}${path}`;
}
